<template>
	<!--首页-->
	<div class="app">
		<navHeader></navHeader>
		<!--轮播-->
		<div id="demo" class="carousel slide" data-ride="carousel">
			<!-- 指示符 -->
			<ul class="carousel-indicators">
				<li data-target="#demo" :data-slide-to="index" v-for="(item,index) in banner" :class="index==0?'active':''"></li>
			</ul>
			<!-- 轮播图片 -->
			<div class="carousel-inner">
				<div class="carousel-item" v-for="(item,index) in banner" :class="index==0?'active':''">
					<img style="width: 100%" :src="item.pictureUrl">
				</div>
			</div>
			<!-- 左右切换按钮 -->
			<a class="carousel-control-prev" href="#demo" data-slide="prev">
				<span class="carousel-control-prev-icon"></span>
			</a>
			<a class="carousel-control-next" href="#demo" data-slide="next">
				<span class="carousel-control-next-icon"></span>
			</a>
		</div>
		<!--<ptList></ptList>-->
		<!--走进金利高-->
		<div class="z-bg">
			<!--走进金利高tit-->
			<div class="comtit">
				<span>走进金利高</span>
				<span>WAlk INTO JIN LIGAO</span>
			</div>
			<!--走进金利高list-->
			<div class="z-list">
				<div class="container">
					<div class="row">
						<div class="col-sm-6" v-for="(item,index) in zList" :class="index>1?' mt-4':''" @click="jumpzList(index)">
							<div class="tit d-flex align-items-center justify-content-between pb-1">
								<p class="d-flex">
									<span>{{item.name}}</span>
									<span class="ml-2">{{item.eg}}</span>
								</p>
								<p><span><img src="../../../static/images/more.png"/></span></p>
							</div>
							<div class="img mt-3">
								<img class="img-fluid" style="width: 100%;" :src="item.img" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--招商加盟-->
		<!--招商加盟tit-->
		<div class="comtit">
			<span>招商加盟</span>
			<span>MERCHANTS JOIN</span>
		</div>
		<div class="c-list pb-5">
			<div class="container">
				<div class="row" id="mous">
					<div class="col-sm-3 col-6 mt-5" v-for="(item,index) in cList" @click="jumpcList">
						<div class="list-li" :class="curr==index?'list-li-on':''" @mouseover="changeActive(index)">
							<div class="img"><img class="img-fluid" style="width: 100%;" :src="item.img" /></div>
							<div class="tit">{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--底部-->
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	import API from '@/components/api/home'
	export default {
		components: {
			navHeader,
			comFooter
		},
		data() {
			return {
				curr: 0,
				banner: [],
				zList: [{
						name: "品牌简介",
						eg: "Brief Introduction of Brand",
						img: '../../../static/images/z-list1.jpg'
					},
					{
						name: "品牌文化",
						eg: "Brief Introduction of Brand",
						img: '../../../static/images/z-list3.jpg'
					},
					{
						name: "品牌荣誉",
						eg: "Brief Introduction of Brand",
						img: '../../../static/images/z-list2.jpg'
					},

					{
						name: "品牌资讯",
						eg: "Brief Introduction of Brand",
						img: '../../../static/images/z-list4.jpg'
					},
				],
				cList: [{
						name: "全球招商",
						img: '../../../static/images/c-list1.jpg'
					},
					{
						name: "我们的优势",
						img: '../../../static/images/c-list2.jpg'
					},
					{
						name: "加盟流程",
						img: '../../../static/images/c-list3.jpg'
					},
					{
						name: "申请加盟",
						img: '../../../static/images/c-list4.jpg'
					},
				]
			}
		},
		created() {},
		mounted() {
			let that = this
			API.getPcContent().then(res => {
				that.banner = res.data.slideshow
			})
		},
		methods: {
			// 鼠标移入加入class
			changeActive(i) {
				this.curr = i
			},
			jumpzList(index) {
				if(index == 3) {
					this.$router.push({
						path: '/news',
					})
				}else{
				this.$router.push({
					path: '/about',
					query: {curr: index}
				})
				}
			},
			jumpcList(){
				this.$router.push({
						path: '/join',
					})
			},
		},
	}
</script>
<style scoped lang="less">
	@w: 19.2vw;
	.z-bg {
		background: url("../../../static/images/zBg.png") no-repeat center;
		background-size: 100% 100%;
		overflow: hidden;
	}
	
	.z-list {
		.tit {
			border-bottom: 1px solid #166BAB;
			p {
				margin: 0;
				&:nth-child(1) {
					span {
						display: block;
						color: #616161;
						font-size: 18/@w;
						&:nth-child(2) {
							color: #D8D8D8;
							font-size: 16/@w;
						}
					}
				}
				&:nth-child(2) {
					span {
						display: block;
						img {
							width: 30/@w;
							min-width: 15px;
							vertical-align: middle;
						}
					}
				}
			}
		}
	}
	
	.c-list {
		background: url("../../../static/images/cBg.png") no-repeat center;
		background-size: 100% 100%;
		overflow: hidden;
		box-sizing: border-box;
		.list-li {
			background: #FBF4E9;
			padding: 15px;
			box-sizing: border-box;
			text-align: center;
			font-size: 18/@w;
			opacity: .4;
			transition: all .3s;
			color: #616161;
			.tit {
				padding-top: 15px;
			}
		}
		.list-li-on {
			opacity: 1;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue